






































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  private openQushi(item: any) {
    this.$emit("openQushi", item);
  }
}
